import React from "react";
import { Link } from "gatsby";
import { Row, Col, Button, Card } from "react-bootstrap";
import { graphql, StaticQuery } from "gatsby";
import { Brands } from "../components/Branding";
import "../assets/css/App.css";
import "../assets/css/index.css";
import "../assets/css/Section.css";
import "../assets/css/Home.css";
import boiler from "../../static/Icons/boiler.png";
import pipe from "../../static/Icons/pipe.png";
import spanner from "../assets/Icons/spanner.png";
import plantroom from "../assets/Icons/plant-room.png";
import Layout from "../components/Layout";
import SEO from "../components/SEO";
import Img from "gatsby-image";
import { RE } from "../components/Reviews";
import { Video } from "../components/Video";
import ContactForm from "../components/ContactForm";
import { ProjectsBlock } from "../components/ProjectsBlock";


export default ({ data }) => (
  <Layout>
    <SEO
      title="BBIS"
      description="BBIS Commercial Heating Engineers London cover all aspects of heating &amp; hot water. Working with commercial heating systems &amp; domestic heating maintenance."
      keywords="central heating service london,central heating services london,london central heating services,boiler and central heating service
      ,boiler central heating service,central heating service providers,oil central heating service,central heating boiler service,gas central heating service,central
       heating service,central heating services,central heating systems london,gas central heating system installation,oil central heating system,gas central heating
        system,new central heating system,electric central heating systems,central heating system"
    />

    <div className="grey-segment" id="home">
      <Row>
        <Col className="text-center pb-4">
          <h1 className="heading-color pb-2 fw-bold">
            London Commercial Heating Solutions That Won't Let You Down
          </h1>
          <p className="">
            BBIS Heating has been providing commercial heating services to businesses in London and Hertfordshire for over 50 years. We’re dedicated to providing an efficient service with excellent customer satisfaction.
          </p>
          <Link to="/contact/">
            <Button variant="primary">Get a Quote</Button>
          </Link>
        </Col>
      </Row>
      <Row className="">
        <Video></Video>
      </Row>
      </div>
      <div className="grey-segment">
        <Row>
        <Col sm className="home-button">
          <Link to="/commercial-boiler-servicing/">
            <img
              alt="Image of boiler"
              className="pb-4 mx-auto d-block home-icon"
              src={boiler}
            />
            <h3 className="heading-color text-center">Boiler Servicing</h3>
            <p className="text-center normal-text-colour">
              Book your annual commercial boiler service with us to keep your
              boiler running safely and efficiently
            </p>
          </Link>
        </Col>
        <Col sm className="home-button">
          <Link to="/commercial-boiler-installations/">
            <img
              alt="Image of pipes"
              className="pb-4 mx-auto d-block home-icon"
              src={pipe}
            />
            <h3 className="heading-color text-center">Boiler Installations</h3>
            <p className="text-center normal-text-colour">
              We fit a wide range of boilers with warranties of up to 12 years
            </p>
          </Link>
        </Col>
        <Col sm className="home-button">
          <Link
            to="/commercial-plant-room-installation-london/"
            className="home-icon"
          >
            <img
              alt="Image of spanner"
              className="pb-4 mx-auto d-block home-icon"
              src={plantroom}
            />
            <h3 className="heading-color text-center">Plant Rooms</h3>
            <p className="text-center normal-text-colour">
              Centralise your HVAC, plumbing and other systems to make
              maintenance and repair easier
            </p>
          </Link>
        </Col>
        <Col sm className="home-button">
          <Link to="/commercial-boiler-repair/" className="home-icon">
            <img
              alt="Image of spanner"
              className="pb-4 mx-auto d-block home-icon"
              src={spanner}
            />
            <h3 className="heading-color text-center">Boiler Repair</h3>
            <p className="text-center normal-text-colour">
              We’ll help you get your boiler back up and running
            </p>
          </Link>
        </Col>
      </Row>
      </div>
      <div className="white-segment">
        <h2 className="heading-color text-center">See what our customers say</h2>
        <RE></RE>
      </div>
      
      <div className="grey-segment text-center">
        <Row>
          <Col className="p-4">
            <hr></hr>
              <h2 className="heading-color">
                Our recent commercial heating projects
              </h2>
              <p>
                From large plant room installations to new underfloor heating systems, we’ve helped businesses with all their heating and cooling needs. Take a look at some of our latest projects and see how we could help you with yours.
              </p>        
          </Col>
        </Row>
<ProjectsBlock/>
        </div>
        <div className="white-segment">
          <Brands />
        </div>
        <div className="grey-segment">
                <Row className="p-1">
        <Col>
          <h2 className="heading-color text-center">
           Working with schools, offices, churches and other large commercial buildings
          </h2>
          
          <p>
            Our expert team can help you with all aspects of commercial heating,
            plumbing and more:
          </p>
          <ul>
            <li>
              <Link to="/commercial-boiler-installations/">Boiler installation</Link>
            </li>
            <li>
              <Link to="/commercial-boiler-servicing/">Boiler servicing</Link>
            </li>
            <li>
              <Link to="/commercial-boiler-repair/">Boiler repair</Link>
            </li>
            <li>
              <Link to="/commercial-power-flushing/">Power flushing</Link>
            </li>
            <li>
              <Link to="/commercial-air-conditioning/">Air conditioning</Link>
            </li>
            <li>
              <Link to="/commercial-catering/">Commercial stove and oven catering equipment</Link>
            </li>
            <li>
              <Link to="commercial-gas-safety-check/">Landlord Gas Safety Certificates</Link>
            </li>
            <li>
              <Link to="/commercial-swimming-pool-boilers/">Swimming pool boilers</Link>
            </li>
            <li>
              <Link to="/commercial-plant-room-installation-london/">Plant room installation and maintenance</Link>
            </li>
          </ul>

          <br></br>
          <p>
            Reach out to a team member or explore our website to learn more
            about our services.
          </p>
        </Col>
      </Row>
    </div>
        <div className="white-segment">
      <Row>
        <Col>
        <h2 className="text-center heading-color">Contact us for a quote</h2>
        <p class="">Fill out our form or call the office on
          <strong><a href="tel:+448002289800">0800 2289800</a></strong>
           and speak to our friendly team to find out more about our gas, heating and plumbing services.{" "}
        </p>
      <ContactForm></ContactForm>
        </Col>
      </Row>
    </div>





  </Layout>
);
export const query = graphql`
  query indeximages {
    marblehouse: file(
      relativePath: { eq: "Projects/marblehouse/marblehouse.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    newmarblehillhouse50: file(
      relativePath: { eq: "Projects/marblehouse/newmarblehillhouse.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    marblehouse1: file(
      relativePath: { eq: "Projects/marblehouse/marblehouse1.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    marblehouse2: file(
      relativePath: { eq: "Projects/marblehouse/marblehouse2.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    marblehouse3: file(
      relativePath: { eq: "Projects/marblehouse/marblehouse3.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    marblehouse4: file(
      relativePath: { eq: "Projects/marblehouse/marblehouse4.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    marblehouse5: file(
      relativePath: { eq: "Projects/marblehouse/marblehouse5.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
    marblehouse6: file(
      relativePath: { eq: "Projects/marblehouse/marblehouse6.jpg" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 945) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
  }
`;
